"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.localiseProperty = void 0;
const assert_1 = require("assert");
const ct_1 = require("../ct");
__exportStar(require("./productSearchQueryAllowedList"), exports);
function localiseProperty(property, store) {
    (0, assert_1.strict)(ct_1.storeToLocales.get(store), `There is no store to locales mapping for store: ${store}`);
    return ct_1.storeToLocales.get(store).map((locale) => `${property}.${locale}`);
}
exports.localiseProperty = localiseProperty;
//# sourceMappingURL=index.js.map